import { render, staticRenderFns } from "./close-page.vue?vue&type=template&id=73fecb8f&"
import script from "./close-page.vue?vue&type=script&lang=ts&"
export * from "./close-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fecb8f')) {
      api.createRecord('73fecb8f', component.options)
    } else {
      api.reload('73fecb8f', component.options)
    }
    module.hot.accept("./close-page.vue?vue&type=template&id=73fecb8f&", function () {
      api.rerender('73fecb8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/close-page/close-page.vue"
export default component.exports